module.exports = __webpack_public_path__ + "img/cafe_thumbnail.dd31e895.jpg";